import PropTypes from 'prop-types';

// TODO: add prop types.
const MessageThreadPropType = {
  // example: PropTypes.string.isRequired,
};

export default MessageThreadPropType;
